/**
 * Rocksoft Locations Settings API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AddAirPlaySecurityProfileToCategoryCommand } from '../model/addAirPlaySecurityProfileToCategoryCommand';
// @ts-ignore
import { CategoryAirPlaySecurityProfileConfiguration } from '../model/categoryAirPlaySecurityProfileConfiguration';
// @ts-ignore
import { CategoryType } from '../model/categoryType';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface AddAirPlaySecurityProfileToCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
    /** The command that contains the data of the AirPlay security profile. */
    addAirPlaySecurityProfileToCategoryCommand?: AddAirPlaySecurityProfileToCategoryCommand;
}

export interface DeleteAirPlaySecurityProfileFromCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
}

export interface GetAirPlaySecurityProfileForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
    /** The id of the AirPlay security profile preset. */
    airPlaySecurityProfilePresetId: string;
}

export interface GetAirPlaySecurityProfilesForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
}


@Injectable({
  providedIn: 'root'
})
export class CategoryAirPlaySecurityConfigurationService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Adds an AirPlay security profile to a category. If the AirPlay security profile already exists for the category, it will be updated. The AirPlay security profile preset must exist before calling this API, otherwise a 404 Not Found response will be returned. If the category does not exist, a 404 Not Found response will be returned.
     * @endpoint post /categories/{categoryType}/{categoryId}/integrations/mdm/airplay-security-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addAirPlaySecurityProfileToCategory(requestParameters: AddAirPlaySecurityProfileToCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryAirPlaySecurityProfileConfiguration>;
    public addAirPlaySecurityProfileToCategory(requestParameters: AddAirPlaySecurityProfileToCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryAirPlaySecurityProfileConfiguration>>;
    public addAirPlaySecurityProfileToCategory(requestParameters: AddAirPlaySecurityProfileToCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryAirPlaySecurityProfileConfiguration>>;
    public addAirPlaySecurityProfileToCategory(requestParameters: AddAirPlaySecurityProfileToCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling addAirPlaySecurityProfileToCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling addAirPlaySecurityProfileToCategory.');
        }
        const addAirPlaySecurityProfileToCategoryCommand = requestParameters?.addAirPlaySecurityProfileToCategoryCommand;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/airplay-security-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryAirPlaySecurityProfileConfiguration>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: addAirPlaySecurityProfileToCategoryCommand,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes the AirPlay security profile from a category. If the AirPlay security profile does not exist for the category, nothing will happen.
     * @endpoint delete /categories/{categoryType}/{categoryId}/integrations/mdm/airplay-security-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteAirPlaySecurityProfileFromCategory(requestParameters: DeleteAirPlaySecurityProfileFromCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteAirPlaySecurityProfileFromCategory(requestParameters: DeleteAirPlaySecurityProfileFromCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteAirPlaySecurityProfileFromCategory(requestParameters: DeleteAirPlaySecurityProfileFromCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteAirPlaySecurityProfileFromCategory(requestParameters: DeleteAirPlaySecurityProfileFromCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling deleteAirPlaySecurityProfileFromCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling deleteAirPlaySecurityProfileFromCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/airplay-security-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a specific AirPlay security profile for a category by the AirPlay security profile preset id.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/airplay-security-profiles/{airPlaySecurityProfilePresetId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getAirPlaySecurityProfileForCategory(requestParameters: GetAirPlaySecurityProfileForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryAirPlaySecurityProfileConfiguration>;
    public getAirPlaySecurityProfileForCategory(requestParameters: GetAirPlaySecurityProfileForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryAirPlaySecurityProfileConfiguration>>;
    public getAirPlaySecurityProfileForCategory(requestParameters: GetAirPlaySecurityProfileForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryAirPlaySecurityProfileConfiguration>>;
    public getAirPlaySecurityProfileForCategory(requestParameters: GetAirPlaySecurityProfileForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getAirPlaySecurityProfileForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getAirPlaySecurityProfileForCategory.');
        }
        const airPlaySecurityProfilePresetId = requestParameters?.airPlaySecurityProfilePresetId;
        if (airPlaySecurityProfilePresetId === null || airPlaySecurityProfilePresetId === undefined) {
            throw new Error('Required parameter airPlaySecurityProfilePresetId was null or undefined when calling getAirPlaySecurityProfileForCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/airplay-security-profiles/${this.configuration.encodeParam({name: "airPlaySecurityProfilePresetId", value: airPlaySecurityProfilePresetId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryAirPlaySecurityProfileConfiguration>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the AirPlay security profiles for a category.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/airplay-security-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getAirPlaySecurityProfilesForCategory(requestParameters: GetAirPlaySecurityProfilesForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CategoryAirPlaySecurityProfileConfiguration>>;
    public getAirPlaySecurityProfilesForCategory(requestParameters: GetAirPlaySecurityProfilesForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CategoryAirPlaySecurityProfileConfiguration>>>;
    public getAirPlaySecurityProfilesForCategory(requestParameters: GetAirPlaySecurityProfilesForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CategoryAirPlaySecurityProfileConfiguration>>>;
    public getAirPlaySecurityProfilesForCategory(requestParameters: GetAirPlaySecurityProfilesForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getAirPlaySecurityProfilesForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getAirPlaySecurityProfilesForCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/airplay-security-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CategoryAirPlaySecurityProfileConfiguration>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
